var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonUserDatabase = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 49 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M21.42 38c8.294 0 15.017-1.888 15.017-4.216 0-2.329-6.723-4.216-15.016-4.216-8.294 0-15.017 1.887-15.017 4.216 0 2.328 6.723 4.216 15.017 4.216z", fill: fills.base }),
        React.createElement("path", { d: "M36.434 22.889H6.404v10.906h30.03V22.888z", fill: fills.base }),
        React.createElement("path", { d: "M21.42 27.027c8.294 0 15.017-1.887 15.017-4.216 0-2.328-6.723-4.216-15.016-4.216-8.294 0-15.017 1.888-15.017 4.216 0 2.329 6.723 4.216 15.017 4.216z", fill: fills.light }),
        React.createElement("path", { d: "M21.42 23.472c8.294 0 15.017-1.887 15.017-4.216 0-2.328-6.723-4.216-15.016-4.216-8.294 0-15.017 1.888-15.017 4.216 0 2.329 6.723 4.216 15.017 4.216z", fill: fills.base }),
        React.createElement("path", { d: "M36.434 8.61H6.404v10.657h30.03V8.61z", fill: fills.base }),
        React.createElement("path", { d: "M21.42 12.746c8.294 0 15.017-1.888 15.017-4.216 0-2.329-6.723-4.217-15.016-4.217-8.294 0-15.017 1.888-15.017 4.217 0 2.328 6.723 4.216 15.017 4.216z", fill: fills.light }),
        React.createElement("path", { d: "M9.76 17.09c.497-.06.839-.62.763-1.249-.075-.63-.54-1.092-1.037-1.032-.497.06-.839.618-.763 1.248.075.63.54 1.092 1.037 1.032zM9.76 31.552c.497-.06.838-.618.763-1.247-.075-.63-.54-1.092-1.037-1.033-.497.06-.839.619-.763 1.248.075.63.54 1.092 1.036 1.032zM42.404 36a8 8 0 11-16 0 8 8 0 0116 0z", fill: fills.dark }),
        React.createElement("path", { d: "M32.02 33.369a2.444 2.444 0 114.887 0 2.444 2.444 0 01-4.887 0zM31.296 37.462a2.644 2.644 0 011.87-.775h2.594a2.644 2.644 0 012.644 2.645v.527a1.06 1.06 0 01-1.06 1.06h-5.763a1.06 1.06 0 01-1.06-1.06v-.527c0-.7.279-1.374.775-1.87z", fill: "#fff" })));
}, {
    name: identiconComponentName,
})({});
